<script setup>
import { RouterView, useRouter } from 'vue-router'
import { onMounted } from 'vue'
import { api } from '@/services/api.js'

const STORAGE_KEY = 'app_version'
const router = useRouter()

onMounted(() => {
  setTimeout(() => {
    router.getRoutes().forEach(route => {
      if (route.components?.default && typeof route.components.default === 'function') {
        route.components.default().catch(() => {})
      }
    })
  }, 3000)
  
  setTimeout(async () => {
    try {
      const { version } = await api.getAppVersion()
      const storedVersion = parseInt(localStorage.getItem(STORAGE_KEY) || '0')
      
      if (version > storedVersion) {
        console.log(`New version detected: ${version}. Reloading...`)
        localStorage.setItem(STORAGE_KEY, version.toString())
        window.location.reload()
      } else {
        localStorage.setItem(STORAGE_KEY, version.toString())
      }
    } catch (error) {
      console.error('Version check failed:', error)
    }
  }, 2000)
})
</script>

<template>
  <div id="app" class="min-h-screen">
    <RouterView />
  </div>
</template>
